import { render, staticRenderFns } from "./ArticlePrices.vue?vue&type=template&id=4d373ba8&"
import script from "./ArticlePrices.vue?vue&type=script&lang=js&"
export * from "./ArticlePrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports